// Copyright 2022 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {createApp} from 'vue'
import App from './App.vue'
import router from './route/index'
import Casdoor from 'casdoor-vue-sdk'

console.log(process.env)

const config = {
  serverUrl: process.env.VUE_APP_CASDOOR_SERVER_URL,
  clientId: process.env.VUE_APP_CASDOOR_CLIENT_ID,
  organizationName: process.env.VUE_APP_CASDOOR_ORG_NAME,
  appName: process.env.VUE_APP_CASDOOR_APP_NAME,
  redirectPath: process.env.VUE_APP_CASDOOR_REDIRECT_PATH,
};

const app = createApp(App)
app.use(Casdoor, config)
app.use(router)
app.mount('#app')
